import type { Article } from '../../../shared/types/index.ts';

/**
 * Temporary local fallbacks for /education/lectures when the articles API /
 * MySQL DB is unavailable. Once lectures are seeded into the DB, the API
 * response takes precedence and these are unused.
 */
export const PLACEHOLDER_LECTURES: Article[] = [
  {
    id: 'placeholder-lecture-1',
    createdAt: '2026-01-14T12:00:00.000Z',
    types: [
      { id: 't1a', type: 'LECTURE', articleId: 'placeholder-lecture-1' },
      { id: 't1b', type: 'WORKSHOP', articleId: 'placeholder-lecture-1' },
      { id: 't1c', type: 'PROFESSIONAL_DEVELOPMENT', articleId: 'placeholder-lecture-1' },
    ],
    title: 'Teachers Professional Development Workshop',
    description:
      'Teachers from various Miami Dade county highschools gathered at the RDF Lab to gain knowledge on 3D printing technology and the RDF Lab developed WebApp.',
    images: [
      {
        id: 'i1a',
        url: 'lectures/lecture-1/a1.jpg',
        articleId: 'placeholder-lecture-1',
      },
      {
        id: 'i1b',
        url: 'lectures/lecture-1/a2.jpg',
        articleId: 'placeholder-lecture-1',
      },
      {
        id: 'i1c',
        url: 'lectures/lecture-1/a3.jpg',
        articleId: 'placeholder-lecture-1',
      },
      {
        id: 'i1d',
        url: 'lectures/lecture-1/a4.jpg',
        articleId: 'placeholder-lecture-1',
      },
      {
        id: 'i1e',
        url: 'lectures/lecture-1/a5.jpg',
        articleId: 'placeholder-lecture-1',
      },
      {
        id: 'i1f',
        url: 'lectures/lecture-1/a6.jpg',
        articleId: 'placeholder-lecture-1',
      },
    ],
    text: 'Teachers from various Miami Dade county highschools gathered at the RDF Lab to gain knowledge on 3D printing technology and the RDF Lab developed WebApp.',
    sourceTitle: '',
    sourceUrl: '',
  },
  {
    id: 'placeholder-lecture-2',
    createdAt: '2026-04-29T12:00:00.000Z',
    types: [
      { id: 't2a', type: 'FIELDTRIP', articleId: 'placeholder-lecture-2' },
      { id: 't2b', type: 'WORKSHOP', articleId: 'placeholder-lecture-2' },
    ],
    title: 'Student Fieldtrip & Workshop #1',
    description:
      'Highschool seniors experienced an all day fieldtrip at FIU and RDF Lab, where they were taught the principles of 3D modeling & 3D printing before diving into the RDF Lab developed EcoShores WebApp.',
    images: [
      {
        id: 'i2a',
        url: 'lectures/lecture-2/a1.jpg',
        articleId: 'placeholder-lecture-2',
      },
      {
        id: 'i2b',
        url: 'lectures/lecture-2/a2.jpg',
        articleId: 'placeholder-lecture-2',
      },
      {
        id: 'i2c',
        url: 'lectures/lecture-2/a3.jpg',
        articleId: 'placeholder-lecture-2',
      },
      {
        id: 'i2d',
        url: 'lectures/lecture-2/a4.jpg',
        articleId: 'placeholder-lecture-2',
      },
      {
        id: 'i2e',
        url: 'lectures/lecture-2/a5.jpg',
        articleId: 'placeholder-lecture-2',
      },
    ],
    text: 'Highschool seniors experienced an all day fieldtrip at FIU and RDF Lab, where they were taught the principles of 3D modeling & 3D printing before diving into the RDF Lab developed EcoShores WebApp.',
    sourceTitle: '',
    sourceUrl: '',
  },
  {
    id: 'placeholder-lecture-3',
    createdAt: '2026-05-26T12:00:00.000Z',
    types: [
      { id: 't3a', type: 'FIELDTRIP', articleId: 'placeholder-lecture-3' },
      { id: 't3b', type: 'WORKSHOP', articleId: 'placeholder-lecture-3' },
    ],
    title: 'Student Fieldtrip & Workshop #2',
    description:
      'Highschool juniors experienced an all day fieldtrip at FIU and RDF Lab, where they were taught the principles of 3D modeling & 3D printing before diving into the RDF Lab developed EcoShores WebApp.',
    images: [
      {
        id: 'i3a',
        url: 'lectures/lecture-3/a1.jpg',
        articleId: 'placeholder-lecture-3',
      },
      {
        id: 'i3b',
        url: 'lectures/lecture-3/a2.jpg',
        articleId: 'placeholder-lecture-3',
      },
      {
        id: 'i3c',
        url: 'lectures/lecture-3/a3.jpg',
        articleId: 'placeholder-lecture-3',
      },
      {
        id: 'i3d',
        url: 'lectures/lecture-3/a4.jpg',
        articleId: 'placeholder-lecture-3',
      },
      {
        id: 'i3e',
        url: 'lectures/lecture-3/a5.jpg',
        articleId: 'placeholder-lecture-3',
      },
      {
        id: 'i3f',
        url: 'lectures/lecture-3/a6.jpg',
        articleId: 'placeholder-lecture-3',
      },
      {
        id: 'i3g',
        url: 'lectures/lecture-3/a7.jpg',
        articleId: 'placeholder-lecture-3',
      },
    ],
    text: 'Highschool juniors experienced an all day fieldtrip at FIU and RDF Lab, where they were taught the principles of 3D modeling & 3D printing before diving into the RDF Lab developed EcoShores WebApp.',
    sourceTitle: '',
    sourceUrl: '',
  },
  {
    id: 'placeholder-lecture-4',
    createdAt: '2026-06-01T12:00:00.000Z',
    types: [
      { id: 't4a', type: 'FIELDTRIP', articleId: 'placeholder-lecture-4' },
      { id: 't4b', type: 'WORKSHOP', articleId: 'placeholder-lecture-4' },
    ],
    title: 'Student Fieldtrip & Workshop #3',
    description:
      'Highschool sophomores experienced an all day fieldtrip at FIU and RDF Lab, where they were taught the principles of 3D modeling & 3D printing before diving into the RDF Lab developed EcoShores WebApp.',
    images: [
      {
        id: 'i4a',
        url: 'lectures/lecture-4/a1.jpg',
        articleId: 'placeholder-lecture-4',
      },
      {
        id: 'i4b',
        url: 'lectures/lecture-4/a2.jpg',
        articleId: 'placeholder-lecture-4',
      },
      {
        id: 'i4c',
        url: 'lectures/lecture-4/a3.jpg',
        articleId: 'placeholder-lecture-4',
      },
      {
        id: 'i4d',
        url: 'lectures/lecture-4/a4.jpg',
        articleId: 'placeholder-lecture-4',
      },
      {
        id: 'i4e',
        url: 'lectures/lecture-4/a5.jpg',
        articleId: 'placeholder-lecture-4',
      },
      {
        id: 'i4f',
        url: 'lectures/lecture-4/a6.jpg',
        articleId: 'placeholder-lecture-4',
      },
    ],
    text: 'Highschool sophomores experienced an all day fieldtrip at FIU and RDF Lab, where they were taught the principles of 3D modeling & 3D printing before diving into the RDF Lab developed EcoShores WebApp.',
    sourceTitle: '',
    sourceUrl: '',
  },
  {
    id: 'placeholder-lecture-5',
    createdAt: '2026-04-30T12:00:00.000Z',
    types: [
      { id: 't5a', type: 'LECTURE', articleId: 'placeholder-lecture-5' },
      { id: 't5b', type: 'WORKSHOP', articleId: 'placeholder-lecture-5' },
      { id: 't5c', type: 'PROFESSIONAL_DEVELOPMENT', articleId: 'placeholder-lecture-5' },
    ],
    title: 'Workshop & Professional Development, Frost Science Museum',
    description:
      'RDF Lab held a full day 3D printing and 3D modeling professional development at Frost Science museum in Miami, Florida.',
    images: [
      {
        id: 'i5a',
        url: 'lectures/lecture-5/a1.jpg',
        articleId: 'placeholder-lecture-5',
      },
      {
        id: 'i5b',
        url: 'lectures/lecture-5/a2.jpg',
        articleId: 'placeholder-lecture-5',
      },
      {
        id: 'i5c',
        url: 'lectures/lecture-5/a3.jpg',
        articleId: 'placeholder-lecture-5',
      },
      {
        id: 'i5d',
        url: 'lectures/lecture-5/a4.jpg',
        articleId: 'placeholder-lecture-5',
      },
    ],
    text: 'RDF Lab held a full day 3D printing and 3D modeling professional development at Frost Science museum in Miami, Florida.',
    sourceTitle: '',
    sourceUrl: '',
  },
  {
    id: 'placeholder-lecture-6',
    createdAt: '2026-06-05T12:00:00.000Z',
    types: [
      { id: 't6a', type: 'WORKSHOP', articleId: 'placeholder-lecture-6' },
      { id: 't6b', type: 'PROFESSIONAL_DEVELOPMENT', articleId: 'placeholder-lecture-6' },
    ],
    title: 'RDF Lab Professional Development',
    description:
      'RDF Lab took part in a Rhino & Grasshopper professional development, learning how parametric design can generate objects for PLA and Clay 3D Printing.',
    images: [
      {
        id: 'i6a',
        url: 'lectures/lecture-6/a1.jpg',
        articleId: 'placeholder-lecture-6',
      },
      {
        id: 'i6b',
        url: 'lectures/lecture-6/a2.jpg',
        articleId: 'placeholder-lecture-6',
      },
      {
        id: 'i6c',
        url: 'lectures/lecture-6/a3.jpg',
        articleId: 'placeholder-lecture-6',
      },
      {
        id: 'i6d',
        url: 'lectures/lecture-6/a4.jpg',
        articleId: 'placeholder-lecture-6',
      },
      {
        id: 'i6e',
        url: 'lectures/lecture-6/a5.jpg',
        articleId: 'placeholder-lecture-6',
      },
    ],
    text: 'RDF Lab took part in a Rhino & Grasshopper professional development, learning how parametric design can generate objects for PLA and Clay 3D Printing.',
    sourceTitle: '',
    sourceUrl: '',
  },
];
